import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { ArrowRight, CheckCircle } from 'react-feather';
import { Colors } from '../../theme';

const Container = styled.div`
  align-items: flex-start;
  display: flex;
  flex-grow: 1;
  flex-basis: 0;

  & + & {
    margin-left: 1em;
  }

  &:last-child .line {
    display: none;
  }

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const Content = styled.div`
  opacity: ${props => props.isActive ? 1 : props.isComplete ? 0.85 : 0.75};
`;

const Title = styled.h3`
  align-items: center;
  color: ${Colors.typography.primary};
  display: flex;
  margin-bottom: .5em;
  opacity: ${props => props.isActive ? 1 : 0.75};
`;

const Description = styled.p`
  font-size: .9em;
  opacity: ${props => props.isActive ? 1 : 0.75};
`;

const IconWrapper = styled.div`
  background: white;
  border-radius: 50%;
  box-shadow: ${Colors.shadows.primary};
  color: ${props => props.isActive ? Colors.brand.primary : Colors.typography.secondary};
  margin-right: 1.5em;
  padding: .5em;

  @media (max-width: 800px) {
    margin-bottom: 1em;
  }

  svg {
    display: inline-block;
    height: auto;
    vertical-align: middle;
    width: 1.75em;
  }
`;

const Line = styled.div`
  border-top: 1px solid rgba(0, 0, 0, .1);
  flex-grow: 1;
  height: 1px;
  margin-left: .5em;

  @media (max-width: 800px) {
    display: none;
  }
`;

const Action = styled.button`
  background: none;
  border: none;
  color: ${Colors.brand.primary};
  cursor: pointer;
`;

const Step = ({ actionLabel = 'Do this', description, icon, isActive, isComplete, onClick, title }) => {
  return (
    <Container>
      <IconWrapper isActive={isActive}>
        {isComplete ? <CheckCircle color={Colors.status.success} /> : icon}
      </IconWrapper>
      <Content isActive={isActive} isComplete={isComplete}>
        <Title isActive={isActive}>{title}<Line className="line" /></Title>
        <Description isActive={isActive}>
          {`${description} `}
          {typeof onClick === 'function' && isActive &&
            <Action onClick={onClick}>{actionLabel} <ArrowRight size={12} /></Action>
          }
        </Description>
      </Content>
    </Container>
  );
};

export default observer(Step);
